import React, { FC } from 'react';
import classNames from 'classnames';
import {
  Alert,
  VisaIcon,
  AmericanExpressIcon,
  MastercardIcon,
  DiscoverIcon,
  DinersIcon,
} from '@clearcover/atlas';
import { PaymentDetailsType } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { AdyenForm } from './AdyenForm';
import styles from './styles.module.css';
import { usePurchaseContext } from 'QuoteApp/services/providers';

export const PaymentMethods: FC<{
  paymentDetails: PaymentDetailsType;
}> = ({ paymentDetails }) => {
  const { errors, submitBind } = usePurchaseContext();
  const method = paymentDetails.paymentMethods[0];
  return (
    <div className={styles.method}>
      <div className={styles.borderContainer}>
        <div className={styles.methodHeader}>
          <div className={classNames(styles.labelHeader, styles.singleMethod)}>
            <div className={styles.creditCardHeading}>
              Credit/Debit Card
              <div className={styles.creditCardIcons}>
                <VisaIcon height={32} width={32} viewBox="0 -1 24 24" />
                <AmericanExpressIcon
                  height={32}
                  width={32}
                  viewBox="0 -1 24 24"
                />
                <MastercardIcon height={32} width={32} />
                <DiscoverIcon height={32} width={32} viewBox="0 1 24 24" />
                <DinersIcon height={24} width={24} viewBox="0 -1 24 24" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.creditCardForm}>
          {errors && (
            <div
              data-testid="payment-error-notification"
              className={styles.errorMessage}
            >
              <Alert message={errors.join(', ')} />
            </div>
          )}
          <div className="fs-mask" data-testid="adyen-form">
            <AdyenForm
              config={method.configuration}
              onPurchaseSubmit={submitBind}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
